import { MDBBtn } from "mdb-react-ui-kit";
import "./RunsheetView.css";

function formatTime(seconds) {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}

export default function RunsheetView({ exhibicion }) {
  const secciones = exhibicion?.secciones || [];

  return (
    <div className="exhi-runsheet">
      <div className="exhi-runsheet-print-btn">
        <MDBBtn size="sm" color="secondary" onClick={() => window.print()}>
          🖨 Imprimir / PDF
        </MDBBtn>
      </div>

      <div className="exhi-runsheet-title">{exhibicion?.titulo}</div>
      {exhibicion?.descripcion && (
        <div className="exhi-runsheet-subtitle">{exhibicion.descripcion}</div>
      )}

      <table className="exhi-runsheet-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Inicio</th>
            <th>Fin</th>
            <th>Duración</th>
            <th>Sección</th>
            <th>Visual</th>
            <th>Audio</th>
            <th>Notas</th>
          </tr>
        </thead>
        <tbody>
          {secciones.map((s, i) => (
            <tr key={s.idSeccion}>
              <td>{i + 1}</td>
              <td>{formatTime(s.tiempoInicio)}</td>
              <td>{formatTime(s.tiempoFin)}</td>
              <td>{s.duracion}s</td>
              <td>
                <strong>{s.titulo}</strong>
                {s.descripcion && <div style={{ fontSize: "0.75rem", color: "#6c757d" }}>{s.descripcion}</div>}
              </td>
              <td>
                {s.medioVisual ? (s.medioVisual.tituloMfm || s.medioVisual.mediaType) : "—"}
              </td>
              <td>
                {s.mediosAudio && s.mediosAudio.length > 0
                  ? s.mediosAudio.map((a, j) => (
                      <div key={j}>{a.tituloMfm || `Pista ${j + 1}`}</div>
                    ))
                  : "—"}
              </td>
              <td></td>
            </tr>
          ))}
        </tbody>
      </table>

      {secciones.length === 0 && (
        <div className="text-muted text-center py-4">Sin secciones.</div>
      )}
    </div>
  );
}
